import React from 'react';

const Features = () => {
  const features = [
    {
      icon: '/img/icon-1.png',
      title: 'Natural Process',
      description: 'We prepare every item using minimal processing to preserve natural nutrients, enzymes, and flavor. From cold-pressed juices to blended smoothies, freshness always comes first.',
      delay: '0.1s'
    },
    {
      icon: '/img/icon-2.png',
      title: 'Every Day Fresh',
      description: 'We are committed to making every bite and sip fresh, every day. Clean fuel for your body to support lasting health.',
      delay: '0.3s'
    },
    {
      icon: '/img/icon-3.png',
      title: 'Biologically Safe',
      description: 'We avoid unnecessary additives and focus on ingredients that are gentle, nourishing, and suitable for a wide range of dietary needs—supporting health from the inside out.',
      delay: '0.5s'
    }
  ];

  return (
    <div className="container-fluid bg-light bg-icon my-5 py-6">
      <div className="container">
        <div className="section-header text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
          <h1 className="display-5 mb-3">Our Features</h1>
          <p>What makes Organique Juice Bar different is our commitment to real ingredients, careful preparation, and wellness-focused choices—made simple and accessible for everyday life.</p>
        </div>
        <div className="row g-4">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={feature.delay}>
              <div className="bg-white text-center h-100 p-4 p-xl-5">
                <img className="img-fluid mb-4" src={feature.icon} alt={feature.title} />
                <h4 className="mb-3">{feature.title}</h4>
                <p className="mb-4">{feature.description}</p>
                {/*<a className="btn btn-outline-primary border-2 py-2 px-4 rounded-pill" href="#">Read More</a>*/}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;